import { render } from "./EditPickupBox.vue?vue&type=template&id=208a5df8&scoped=true&ts=true"
import script from "./EditPickupBox.vue?vue&type=script&lang=ts"
export * from "./EditPickupBox.vue?vue&type=script&lang=ts"

import "./EditPickupBox.vue?vue&type=style&index=0&id=208a5df8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208a5df8"]])

export default __exports__